import React from 'react'
import Page from '../components/Page'

import NavigationData from '../data/nav.remotejson.js'
import FooterNavData from '../data/footerNav.remotejson.js'
import { getWpData } from '../data/general'

import AboutUs from '../views/AboutUs'
import Careers from '../views/Careers'
import Contact from '../views/Contact'
import Documentary from '../views/Documentary'
import Donate from '../views/Donate'
import Events from '../views/Events'
import Faqs from '../views/Faqs'
import Financials from '../views/Financials'
import GetInvolved from '../views/GetInvolved'
import OurImpact from '../views/OurImpact'
import Partners from '../views/Partners'
import Scholarships from '../views/Scholarships'
import Club from '../views/Club.js'

const getTemplate = templateUri => {
  const templates = {
    'page-templates/about-us.php': AboutUs,
    'page-templates/careers.php': Careers,
    'page-templates/contact.php': Contact,
    'page-templates/documentary.php': Documentary,
    'page-templates/donate.php': Donate,
    'page-templates/events.php': Events,
    'page-templates/faqs.php': Faqs,
    'page-templates/single.php': Financials,
    'page-templates/get-involved.php': GetInvolved,
    'page-templates/our-impact.php': OurImpact,
    'page-templates/partners.php': Partners,
    'page-templates/scholarships.php': Scholarships,
    'page-templates/club.php': Club
  }

  return templates[templateUri]
}

export default function Slug (props) {
  const Template = getTemplate(props.wp.template)

  return Template ? <Template {...props} /> : <Page {...props}></Page>
}

export async function getStaticProps ({ params }) {
  console.log(params.slug, '\n')
  // These pages don't seem to have any ACF fields.
  // The only fields necessary from the design are title (provided by WP) and bg image.
  const page = {
    acf: {
      hero: {
        title: "Alyssa's Story" || fullArticle.title.rendered,
        body: 'By: Firstname Lastname' || fullArticle.title.rendered,
        bgImage: 'https://placekitten.com/1920/1080'
      }
    },
    params
  }

  const wpData = {
    ...(await getWpData('pages', params.slug))
  }

  return {
    props: {
      page,
      ...wpData
    }
  }
}

export async function getStaticPaths () {
  let blacklistedSlugs = new Set([
    'news',
    'stories',
    'merch',
    'media',
    'press',
    'leadership',
    'terms-of-use',
    'privacy-policy',
    'galleries'
  ])
  // Collect the paths that tell Next.js to generate pages at these URLs
  let MenuData = [...NavigationData.items, ...FooterNavData.items]

  const paths = MenuData.reduce((acc, item) => {
    let children = item.child_items || []
    let slugs = item.slug
      ? [{ params: { slug: item.slug } }]
      : children
          .filter(child => !blacklistedSlugs.has(child.slug))
          .map(child => ({ params: { slug: child.slug } }))

    return [...acc, ...slugs.filter(item => item.params.slug)]
  }, [])

  return {
    paths,

    fallback: false
  }
}
